import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "./api";
import { syncAttempts, userIdFromToken } from "./offlineChapters";

/**
 * Sends quiz attempts that were finished offline. Runs when the app opens and whenever the device comes
 * back online. The server is idempotent on attempt_id, so a repeat send never creates a duplicate.
 */
export function useAttemptSync(): void {
  const { tokens } = useAuth();
  const token = tokens?.accessToken ?? "";

  useEffect(() => {
    const userId = userIdFromToken(token);
    if (!token || !userId) return;
    const run = () => {
      if (typeof navigator !== "undefined" && navigator.onLine === false) return;
      void syncAttempts(userId, (a) => api.student.chapters.submitAttempt(token, a)).catch(() => undefined);
    };
    run();
    window.addEventListener("online", run);
    return () => window.removeEventListener("online", run);
  }, [token]);
}
